// This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

// const ListUI = require('./js/list-ui.js')
const RightNowSurvey = require('./js/rightnow-survey.js')
const IdentificationUI = require('./js/identification-ui.js')
const ContactDetailsUI = require('./js/contact-details-ui.js')
const PasswordSetUI = require('./js/password-set-ui.js')
const OffersUI = require('./js/offers-ui.js')

module.exports = exports = {
   // Modules to expose to the application pages
   RightNowSurvey,
   IdentificationUI,
   ContactDetailsUI,
   OffersUI,
   PasswordSetUI
}
